// @flow
import type { Action } from 'store/types';

import * as c from '../constants';

export function checkActionIsRouteAction(action: Action<*>): boolean {
  return new RegExp(`^@${c.MODULE_NAME}`).test(action.type);
}

export default checkActionIsRouteAction;



// WEBPACK FOOTER //
// ./src/modules/router/helpers/checkActionIsRouteAction.js